/**
 * How many random items a member gets for a victory: the crucible's count,
 * one more for a full clear. None, full clear or not, while the crucible's
 * victory items are off.
 */
export function resolveVictoryItemCount(victoryItemRewardCount: number, isFullClear: boolean): number {
    return victoryItemRewardCount > 0 ? victoryItemRewardCount + (isFullClear ? 1 : 0) : 0;
}
